import { apiSlice } from "./apiSlice";

export const mediaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMedia: builder.mutation({
      query: (mediaData) => ({
        url: "/media/createMedia",
        method: "POST",
        body: mediaData,
      }),
      invalidatesTags: ["Media"],
    }),

    deleteMedia: builder.mutation({
      query: (id) => ({
        url: `/media/deleteMedia/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Media"],
    }),

    updateMedia: builder.mutation({
      query: ({ mediaData, id }) => ({
        url: `/media/updateMedia/${id}`,
        method: "PATCH",
        body: mediaData,
      }),
      invalidatesTags: ["Media"],
    }),

    getAllMedia: builder.query({
      query: () => ({
        url: "/media/getAllMedia",
        method: "GET",
      }),
      providesTags: ["Media"],
    }),

    getMediaById: builder.query({
      query: (id) => ({
        url: `/media/getMediaById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateMediaMutation,
  useUpdateMediaMutation,
  useDeleteMediaMutation,
  useGetAllMediaQuery,
  useGetMediaByIdQuery,
} = mediaApi;
